'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = HalfRichText;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _RichText = require('../RichText');

var _RichText2 = _interopRequireDefault(_RichText);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*
   half_rich_text
   {
     "type": "half_rich_text",
     "title": "An optional title",
     "content": "..."
   }

   This is the only module that is specifically 50% width. This module
   should usually come in pairs (so, there should be two elements in the
   array, each half_rich_text modules).

   Other than the width, it is identical to rich_text.
 */
function HalfRichText(_ref) {
  var moduleClass = _ref.moduleClass,
      title = _ref.title,
      content = _ref.content;

  return _react2.default.createElement(_RichText2.default, {
    moduleClass: 'type-half_width ' + moduleClass,
    title: title,
    content: content
  });
}
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/shared/modules/HalfRichText/HalfRichText.jsx
// module id = 1159
// module chunks = 0